const CuracaoSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_111271)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#FFDA44"
      />
      <path
        d="M20.0003 39.9999C26.5628 39.9999 32.387 36.8391 36.0338 31.957H3.9668C7.61367 36.8391 13.4378 39.9999 20.0003 39.9999Z"
        fill="#0052B4"
      />
      <path
        d="M40 20C40 8.95437 31.0456 0 20 0C8.95437 0 0 8.95437 0 20C0 22.3651 0.411641 24.6338 1.16531 26.7398H38.8346C39.5884 24.6338 40 22.3651 40 20Z"
        fill="#0052B4"
      />
      <path
        d="M13.6892 12.8271L14.7683 16.1484H18.2608L15.4354 18.2014L16.5146 21.5228L13.6892 19.47L10.8638 21.5228L11.9431 18.2014L9.11768 16.1484H12.61L13.6892 12.8271Z"
        fill="#F0F0F0"
      />
      <path
        d="M7.69154 9.34863L8.33904 11.3414H10.4346L8.73936 12.5732L9.38686 14.5661L7.69154 13.3343L5.99631 14.5661L6.64389 12.5732L4.94873 11.3414H7.0442L7.69154 9.34863Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111271">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default CuracaoSvg;
